module.exports = __webpack_public_path__ + "img/project-setup-steps.c5f200a6.svg";